(function () {
  if (customElements.get('header-drawer')) return;

  class HeaderDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-drawer-toggle]');
      this.closers = this.querySelectorAll('[data-drawer-close]');
      if (!this.toggleButton) return;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.toggleButton.addEventListener('click', this.open);
      this.closers.forEach((el) => el.addEventListener('click', this.close));

      /* Untermenü-Accordion im Mobile-Drawer */
      this.querySelectorAll('[data-submenu-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.header__menu-item');
          if (!item) return;
          const willOpen = !item.classList.contains('is-open');

          /* andere offene Untermenüs schließen */
          this.querySelectorAll('.header__menu-item.is-open').forEach((other) => {
            if (other === item) return;
            other.classList.remove('is-open');
            const otherBtn = other.querySelector('[data-submenu-toggle]');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });

          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });

      /* Desktop-Dropdowns: Hover/Focus mit Overlay-Abdunklung */
      const header = this.closest('.header');
      const parents = this.querySelectorAll('.header__menu-item--has-children');
      const isDesktop = () => window.innerWidth >= 750;
      let closeTimer;

      const updateOverlay = () => {
        if (header) {
          header.classList.toggle('is-submenu-open', !!this.querySelector('.header__menu-item--has-children.is-open'));
        }
      };
      const openItem = (item) => {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        parents.forEach((p) => {
          if (p !== item) p.classList.remove('is-open');
        });
        item.classList.add('is-open');
        updateOverlay();
      };
      const closeItem = (item) => {
        item.classList.remove('is-open');
        updateOverlay();
      };

      parents.forEach((item) => {
        item.addEventListener('mouseenter', () => openItem(item));
        item.addEventListener('mouseleave', () => {
          if (!isDesktop()) return;
          closeTimer = setTimeout(() => closeItem(item), 150);
        });
        item.addEventListener('focusin', () => openItem(item));
        item.addEventListener('focusout', (event) => {
          if (!isDesktop()) return;
          if (!item.contains(event.relatedTarget)) closeItem(item);
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.style.overflow = '';
    }

    open() {
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
})();

/* --- Sticky Navbar: Schatten erst beim Scrollen --- */
(function () {
  function initSticky() {
    var header = document.querySelector('.header[data-sticky="true"]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState !== 'loading') {
    initSticky();
  } else {
    document.addEventListener('DOMContentLoaded', initSticky);
  }
})();
